import { Box, Button, Stack, Typography } from '@mui/material';
import DisplayPrice from 'components/Common/DisplayValues/DisplayPrice';
import Counter from 'components/RouteWizard/Counter';
import { useWizard } from 'components/RouteWizard/Wizard';
import useClient from 'hooks/useClient';
import IconChaffuer from '../../../../assets/icon/icon-chaffeur.svg';
import IconGreenBadge from '../../../../assets/icon/icon-green-badge.svg';
interface Props {
  data: any
  selectMultiple: boolean
  keyValue: number
  type: 'inBound' | 'outBound'
  handleChangeVehicle: (data: any) => void
  handleMultipleVehicleChange: (
    key: number,
    type: 'inBound' | 'outBound',
    operator: 'positive' | 'negative',
  ) => void
}

const SelectedVehicles = ({
  data,
  selectMultiple,
  keyValue,
  type,
  handleChangeVehicle,
  handleMultipleVehicleChange,
}: Props) => {
  const { data: wizardData } = useWizard()
  const { displayVATPrice } = useClient(wizardData.account.clientId)

  const isChauffeur = data.title?.toLowerCase()?.includes('chauffer')
  const isEco =
    data.title?.toLowerCase()?.includes('zero') ||
    data.title?.toLowerCase()?.includes('hybrid')

  return (
    <Box
      sx={{
        border: '1px solid #e2e6ea',
        borderRadius: '8px',
        bgcolor: '#f7f7f7',
        overflow: 'hidden',
      }}
    >
      <Stack direction="row" spacing={1.5} sx={{ p: 1.5 }} alignItems="stretch">
        <Box
          sx={{
            position: 'relative',
            width: 96,
            height: 72,
            flexShrink: 0,
            alignSelf: 'center',
          }}
        >
          {data.image && (
            <Box
              component="img"
              src={data.image}
              alt=""
              sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          )}
          {isChauffeur && (
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: 24,
                height: 24,
                borderRadius: '50%',
                bgcolor: '#fff',
                border: '1px solid #d0d6dc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                component="img"
                src={IconChaffuer}
                sx={{ width: 14, height: 14 }}
              />
            </Box>
          )}
          {isEco && (
            <Box
              sx={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: 24,
                height: 24,
                borderRadius: '50%',
                bgcolor: '#e6f4ec',
                border: '1px solid #b7dcc4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                component="img"
                src={IconGreenBadge}
                sx={{ width: 14, height: 14 }}
              />
            </Box>
          )}
        </Box>

        <Stack flex={1} spacing={0.5} sx={{ minWidth: 0 }}>
          <Stack direction="row" spacing={1} alignItems="flex-start">
            <Box sx={{ flex: 1, minWidth: 0 }}>
              {data.title && (
                <Typography
                  sx={{
                    color: '#00253d',
                    fontWeight: 700,
                    fontSize: 14,
                    lineHeight: 1.25,
                  }}
                >
                  {data.title}
                </Typography>
              )}
              {data.example && (
                <Typography
                  sx={{
                    color: '#5a6670',
                    fontSize: 11,
                    lineHeight: 1.3,
                    mt: 0.25,
                  }}
                >
                  {data.example}
                </Typography>
              )}
              {data.quotes?.isPreferredSupplier &&
                data.quotes?.supplierName && (
                  <Typography
                    sx={(theme) => ({
                      color: theme.palette.brand.dark,
                      fontWeight: 700,
                      fontSize: 11,
                      lineHeight: 1.4,
                      textTransform: 'uppercase',
                      letterSpacing: '0.04em',
                      mt: 0.5,
                    })}
                  >
                    {data.quotes.supplierName}
                  </Typography>
                )}
            </Box>
            <Stack alignItems="flex-end" spacing={0.25} sx={{ flexShrink: 0 }}>
              <Box
                sx={{
                  color: '#00253d',
                  fontWeight: 700,
                  fontSize: 18,
                  lineHeight: 1.1,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                {DisplayPrice({
                  VATTotalPrice: data.quotes.price,
                  displayVATPrice: displayVATPrice,
                })}
              </Box>
              <Typography
                sx={{
                  color: '#888888',
                  fontWeight: 400,
                  fontSize: 10,
                  lineHeight: 1.2,
                  letterSpacing: '0.04em',
                }}
              >
                ESTIMATED
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      <Stack
        direction="row"
        spacing={1}
        sx={{ px: 1.5, pb: 1.5 }}
        alignItems="center"
      >
        <Box flex={1} />
        {selectMultiple ? (
          <Counter
            value={data?.vehicleData?.quantity || 0}
            label=""
            negativeOnClick={() =>
              data?.vehicleData?.quantity > 1
                ? handleMultipleVehicleChange(keyValue, type, 'negative')
                : null
            }
            positiveOnClick={() =>
              handleMultipleVehicleChange(keyValue, type, 'positive')
            }
            positiveDisabled={false}
          />
        ) : (
          <Button
            sx={{
              backgroundColor: '#fff',
              border: '1px solid var(--jy-navy-900, #00253d)',
              color: 'var(--jy-navy-900, #00253d)',
              padding: '6px 14px',
              fontSize: 12,
              minHeight: 32,
              '&:hover': {
                color: '#fff',
              },
            }}
            onClick={() => handleChangeVehicle(data)}
          >
            CHANGE
          </Button>
        )}
      </Stack>
    </Box>
  )
}

export default SelectedVehicles
